<template>
    <!-- <div style="margin:0 auto;width:1334px;position: fixed;bottom: 183px;left: 0;right: 0;">
        <div style="position:absolute;right:0;bottom:0;">
            <div style="background: rgba(255,255,255,0.30);border-radius: 5px;width:60px;height:60px;">
                <img src="../../assets/images/newComebackTop.png"/>
            </div>
            <div style="background: rgba(255,255,255,0.50);border-radius: 5px;width:60px;height:60px;margin-top:20px;text-align: center;">
                <p style="font-size: 14px;color: #CDCDCD;height:27px;padding-top:13px;">在线</p>
                <p style="font-size: 14px;color: #CDCDCD;height:14px;line-height:14px;margin-top:5px;">客服</p>
            </div>
        </div>
    </div> -->
    <!-- <div style="position: fixed;bottom:50px;right:50px;">
        <div>
            <div id="to-top-btn" @click="backtop" style="cursor:pointer;background: rgba(255,255,255,0.30);border-radius: 5px;width:60px;height:60px;display:none">
                <img src="../../assets/images/newComebackTop.png"/>
            </div>
            <div @click='showKefu' style="background: rgba(255,255,255,0.50);border-radius: 5px;width:60px;height:60px;margin-top:20px;text-align: center;">
                <p style="font-size: 14px;color: #CDCDCD;height:27px;padding-top:13px;">在线</p>
                <p style="font-size: 14px;color: #CDCDCD;height:14px;line-height:14px;margin-top:5px;">客服</p>
            </div>
        </div>
    </div> -->
    <div class="meiqia_box">
        <div :class="(meiqia_open ? 'active meiqia_left' : 'meiqia_left')" @click="closeMeiqia()">联系我们</div>
        <div v-if="meiqia_open" class="meiqia_box_main" style="margin-top: 117px;">
            <!-- <h3 class="meiqia_box_title"></h3> -->
            <div class="return_top" :style="{display:!scrollBtnFlag?'none':'block',height:!scrollBtnFlag?'0px':'42px'}">
                <div class="return_top_btn" @click="backTop">返回顶部</div>
            </div>
            <ul class="meiqia_box_text">
                <li class="meiqia_box_text_item">全国免费服务热线</li>
                <li class="meiqia_box_text_item">400-878-5066</li>
            </ul>

        </div>
    </div>
</template>
<script>
    import $ from 'jquery'
    export default {
        data(){
            return {
                meiqia_open: false,
                scrollBtnFlag: false,
            }
        },
        destroyed () {
            window.removeEventListener('scroll', this.showbtn); 
        },
        mounted(){
            window.addEventListener("scroll",this.showbtn,true);
        },
        methods:{
            //关闭美洽浮窗
            closeMeiqia() {
                this.meiqia_open = !this.meiqia_open;
            },
            // 显示回到顶部按钮
            showbtn(){
                let that = this;
                // let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                // console.log(scrollTop)
                // that.scrollTop = scrollTop-$(window).height()
                // let topBtn = document.getElementById('to-top-btn');
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                let browserHeight = window.innerHeight;
                if (scrollTop > 200) {
                    that.scrollBtnFlag = true
                } else {
                    that.scrollBtnFlag = false
                }
            },
            backTop(){
                var timer = setInterval(function(){
                    let osTop = document.documentElement.scrollTop || document.body.scrollTop;
                    let ispeed = Math.floor(-osTop / 5); 
                    document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
                    this.isTop = true;
                    if(osTop === 0){
                        clearInterval(timer);
                    }
                },30)
            },
            showKefu(){

            }
        }
    }
</script>
<style lang="less">
    
    .meiqia_box {
        right: 0;
        top: 50%;
        position: fixed;
        overflow: hidden;
        margin-top: -200px;
        z-index: 999;


        .meiqia_left {
            width: 28px;
            height: 130px;
            background: rgba(254, 216, 0, 1);
            border-radius: 3px 0 0 3px;
            text-align: center;
            color: #05050C;
            font-size: 13px;
            font-weight: 500;
            margin-top: 117px;
            padding: 25px 7px 0 8px;
            box-sizing: border-box;
            line-height: 1.2;
            cursor: pointer;
            float: left;

            &:after {
                content: '';
                width: 12px;
                height: 12px;
                display: inline-block;
                margin-top: 6px;
                background: url(../../assets/meiqia_left.png) no-repeat left center;
                background-size: 100% 100%;
            }

            &.active:after {
                content: '';
                width: 12px;
                height: 12px;
                display: inline-block;
                margin-top: 6px;
                background: url(../../assets/meiqia_right.png) no-repeat left center;
                background-size: 100% 100%;
            }

        }

        .meiqia_box_main {
            // padding: 22px 12px;
            height: 130px;
            flex-direction: column;
            box-sizing: border-box;
            width: 138px;
            background: #05050C;
            border-radius: 4px 0 0 4px;
            text-align: center;
            float: left;
            display:flex;
            justify-content: center;
            align-items:center;
            .meiqia_box_title {
                font-weight: 500;
                font-size: 18px;
                color: #FED800;
            }

            .meiqia_box_group {
                list-style: none;
                padding-top: 16px;

                .meiqia_box_item {
                    width: 114px;
                    height: 32px;
                    line-height: 32px;
                    text-align: center;
                    border-radius: 3px;
                    border: 1px solid rgba(254, 216, 0, 1);
                    color: #FED800;
                    margin-bottom: 10px;
                    cursor: pointer;
                }
            }

            .return_top {
                padding-bottom: 34px;

                .return_top_btn {
                    padding:0px 15px;
                    width: 100%;
                    height: 32px;
                    line-height: 32px;
                    background: #FED800;
                    border-radius: 3px;
                    color: #05050C;
                    font-size: 14px;
                    cursor: pointer;

                    &:after {
                        content: '';
                        padding-left: 16px;
                        height: 14px;
                        background: url(../../assets/meiqia_back.png) no-repeat right top;
                        background-size: 14px 14px;

                    }
                }
            }

            .meiqia_box_text {
                list-style: none;
                color: #FED800;
                font-size: 13px;

                .meiqia_box_text_item {
                    padding-top: 9px;
                    line-height: 1;
                }

            }
        }

    }
</style>


// WEBPACK FOOTER //
// src/layout/onlineService/onlineService.vue